var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorBookImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 99,
    viewBox: "0 0 98 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.9147 11.9677L82.0526 78.1179L39.0028 73.0006L32.5267 72.2317L31.0656 72.0574L30.9648 72.0462L31.2078 70.0048L31.4189 68.2367L35.3067 35.5093L38.6239 7.59706L38.8254 5.89771L52.0557 7.46917L89.9147 11.9677Z",
    fill: "#BBBDBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2601 60.8926C68.1562 60.8926 68.0603 60.8238 68.0299 60.7183L53.0699 7.89445C53.0331 7.76656 53.1083 7.63388 53.2346 7.59871C53.3624 7.56194 53.4951 7.63707 53.5303 7.76337L68.4919 60.5872C68.5287 60.7151 68.4536 60.8478 68.3273 60.883C68.3033 60.8894 68.2825 60.8926 68.2601 60.8926Z",
    fill: "#1D232A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6135 66.4173L36.1898 72.4266L32.5273 71.987L32.684 70.1421L35.3074 35.1591L37.4256 6.92233L38.7205 6.32764L53.3017 7.82876L68.6135 66.4173Z",
    fill: "#1D232A",
    stroke: "#1D232A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7178 -0.000107383L0.5 11.1897L14.9888 76.2129L65.2066 65.0231L50.7178 -0.000107383Z",
    fill: "#E8E9EA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6308 21.8106C10.5205 21.8106 10.4214 21.7339 10.3974 21.6236C10.3686 21.4941 10.4501 21.3662 10.5796 21.3374L45.8983 13.4657C46.0278 13.4354 46.1557 13.5185 46.1845 13.648C46.2132 13.7775 46.1317 13.9054 46.0022 13.9341L10.6835 21.8058C10.6659 21.809 10.6484 21.8106 10.6308 21.8106Z",
    fill: "#1D232A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9257 32.1105C12.8154 32.1105 12.7163 32.0337 12.6923 31.9234C12.6635 31.7939 12.7451 31.666 12.8745 31.6373L48.1933 23.7655C48.3211 23.7352 48.4506 23.8183 48.4794 23.9478C48.5082 24.0773 48.4267 24.2052 48.2972 24.2339L12.9785 32.1041C12.9609 32.1073 12.9433 32.1105 12.9257 32.1105Z",
    fill: "#1D232A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2226 42.4091C15.1123 42.4091 15.0132 42.3323 14.9892 42.222C14.9604 42.0925 15.0419 41.9646 15.1714 41.9359L50.4902 34.0641C50.6197 34.0354 50.7476 34.1169 50.7763 34.2464C50.8051 34.3759 50.7236 34.5038 50.5941 34.5325L15.2753 42.4027C15.2577 42.4059 15.2402 42.4091 15.2226 42.4091Z",
    fill: "#1D232A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5175 52.7074C17.4072 52.7074 17.3081 52.6323 17.2841 52.5204C17.2553 52.3909 17.3369 52.263 17.4663 52.2342L52.7851 44.3625C52.9146 44.3337 53.0425 44.4152 53.0713 44.5447C53.1 44.6742 53.0185 44.8021 52.889 44.8309L17.5703 52.7026C17.5511 52.7058 17.5335 52.7074 17.5175 52.7074Z",
    fill: "#1D232A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8105 63.006C19.7002 63.006 19.601 62.9308 19.5771 62.8189C19.5483 62.6894 19.6298 62.5616 19.7593 62.5328L44.6821 56.9775C44.81 56.9487 44.9395 57.0302 44.9683 57.1597C44.997 57.2892 44.9155 57.4171 44.786 57.4459L19.8632 63.0012C19.8456 63.0044 19.8281 63.006 19.8105 63.006Z",
    fill: "#1D232A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2767_44373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.5952 93.9999C86.4837 93.9999 94.5 85.9837 94.5 76.0952C94.5 66.2067 86.4837 58.1904 76.5952 58.1904C66.7067 58.1904 58.6904 66.2067 58.6904 76.0952C58.6904 85.9837 66.7067 93.9999 76.5952 93.9999Z",
    fill: "#4A4F55"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1855 82.0279C85.9192 82.7631 85.9192 83.9523 85.1855 84.686C84.8187 85.0528 84.3376 85.2362 83.8565 85.2362C83.3753 85.2362 82.8942 85.0528 82.5274 84.686L76.5947 78.7533L70.6605 84.686C70.2937 85.0528 69.8126 85.2362 69.3315 85.2362C68.8504 85.2362 68.3693 85.0528 68.0024 84.686C67.2687 83.9523 67.2687 82.7631 68.0024 82.0279L73.9366 76.0952L68.0024 70.161C67.2687 69.4273 67.2687 68.2366 68.0024 67.5029C68.7361 66.7692 69.9253 66.7692 70.6605 67.5029L76.5947 73.4371L82.5274 67.5029C83.2611 66.7692 84.4518 66.7692 85.1855 67.5029C85.9192 68.2366 85.9192 69.4273 85.1855 70.161L79.2528 76.0952L85.1855 82.0279Z",
    fill: "#FCFCFC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2767_44373",
    x: 55.6904,
    y: 57.1904,
    width: 41.8096,
    height: 41.8096,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0.309804 0 0 0 0 0.333333 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2767_44373"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2767_44373",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorBookImage);
export default __webpack_public_path__ + "static/media/errorBookImage.799e951fcab68aab7fb350f28625b9ad.svg";
export { ForwardRef as ReactComponent };